import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ListResult } from '../../../api/core/list-result';
import { LookupItem } from '../../../api/data-model';
import { LookupService } from '../../../services/service';
import { BasePickerComponent } from './base-picker.component';

@Component({
  selector: 'app-user-picker',
  standalone: true,
  imports: [FormsModule, AutoCompleteModule],
  templateUrl: './base-picker.component.html',
  providers: [
    LookupService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UserPickerComponent),
      multi: true,
    },
  ],
})
export class UserPickerComponent extends BasePickerComponent<LookupItem> {
  @Input() roles: string[] | undefined = undefined;
  @Input() isSigningAttorney: boolean = false;

  constructor(private readonly lookupService: LookupService) {
    super();
  }

  override search(query: string): Observable<ListResult<LookupItem>> {
    return this.lookupService.getUsers(undefined, query, this.roles, 20, this.isSigningAttorney);
  }

  override load(keys: string[]): Observable<ListResult<LookupItem>> {
    return this.lookupService.getUsers(keys,undefined,undefined,undefined,this.isSigningAttorney);
  }
}
